const enum RouteNames {
  Login = 'Login',
  Layout = 'Layout',

  Home = 'Home',
  InternalWeb = 'InternalWeb',
  Requirements = 'Requirements',

  // Setting
  Setting = 'Setting',
  Setting_User = 'Setting_User', // 后台用户设置
  Setting_Role = 'Setting_Role', //后台角色管理

  // AZAN
  Azan = 'Azan',
  // azan 铃声
  Azan_Ring = 'Azan_Ring',
  // 收集的 azan 时间
  Azan_Time = 'Azan_Time',
  // azan 祷告图像
  Azan_Prayer = 'Azan_Prayer',
  // 地区代码管理
  Azan_Regions = 'Azan_Regions',
  // 礼拜时间管理
  Azan_PrayerTimes = 'Azan_PrayerTimes',

  // app管理
  App = 'app',
  App_Feedback = 'feedback', // 反馈管理
  App_Software = 'software', // 软件管理
  App_Equipment = 'equipment', // 设备管理 
  App_User = 'User', // 用户管理
  App_Tasks = 'tasks', // 任务管理
  App_Counts = 'counts', // 计数管理
  
  // 仪表板
  Dashboard = 'Dashboard', 

  // Mine
  Mine = 'Mine',
  My_AccountSettings = 'My_AccountSettings',
  My_Activities = 'My_Activities',
  My_Info = 'My_Info',
  My_Messages = 'My_Messages',

  // Error
  Error = 'Error',
  Error403 = '403',
  Error404 = '404',

  // SplitScreen
  SplitScreen = 'SplitScreen',
  SplitScreen_Redirect = 'SplitScreen_redirect',

  Guidance = 'Guidance',
  Settings = 'Settings',

  // DevTools
  DevTools = 'DevTools',
  DevTools_Playground = 'DevTools_Playground',

  // 组件
  ComponentDemo = 'Components',
  ComponentDemo_Base = 'ComponentDemo_Base',
  ComponentDemo_JsonEditor = 'ComponentDemo_JsonEditor',
  ComponentDemo_DiffText = 'ComponentDemo_DiffText',
  ComponentDemo_Table = 'ComponentDemo_Table',

  // 多级菜单
  MultiLevelMenu = 'MultiLevelMenu',
  MultiLevelMenu_Level1 = 'MultiLevelMenu_Level1',
  MultiLevelMenu_Level2 = 'MultiLevelMenu_Level2',
  MultiLevelMenu_Level3 = 'MultiLevelMenu_Level3',
}

export default RouteNames
